// export const EGORAS_PAY_URL = "http://localhost:4005";
// export const EGORAS_PAY_TESTNET = "https://sandbox.egoras.com/";
// export const EGORAS_PAY_URL = EGORAS_PAY_TESTNET;
export const EGORAS_PAY_URL = "https://dataseed.egoras.com";
export const MART_GPT_URL = "https://egoras-v3-staging.egoras.com";
